export default "/_next/static/images/664873216b7e252cb71debbc64e3ed6f.jpg";